import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	jiraSoftwareHeading: {
		id: 'projects-directory-v3.page-layout.empty-view.jira-software-heading',
		defaultMessage: "You don't have any software projects",
		description: 'Projects Directory empty state heading for Jira Software context',
	},
	jiraSoftwareDescription: {
		id: 'projects-directory-v3.page-layout.empty-view.jira-software-description',
		defaultMessage:
			'Create a new software project to plan, track, and release great software with your team.',
		description: 'Projects Directory empty state description for Jira Software context',
	},
	jiraServiceManagementHeading: {
		id: 'projects-directory-v3.page-layout.empty-view.jira-service-management-heading',
		defaultMessage: 'You don’t have any service projects',
		description: 'Projects Directory empty state heading for Jira Service Management context',
	},
	jiraServiceManagementDescription: {
		id: 'projects-directory-v3.page-layout.empty-view.jira-service-management-description',
		defaultMessage:
			'Create a new service project to give your customers a place to ask for help, report incidents, and request new services.',
		description: 'Projects Directory empty state description for Jira Service Management context',
	},
	jiraCoreHeading: {
		id: 'projects-directory-v3.page-layout.empty-view.jira-core-heading',
		defaultMessage: "You don't have any business projects",
		description: 'Projects Directory empty state heading for Jira Core context',
	},
	jiraCoreDescription: {
		id: 'projects-directory-v3.page-layout.empty-view.jira-core-description',
		defaultMessage:
			'Create a new business project to manage tasks, monitor details, and measure performance with your team.',
		description: 'Projects Directory empty state description for Jira Core context',
	},
	jiraProductDiscoveryHeading: {
		id: 'projects-directory-v3.page-layout.empty-view.jira-product-discovery-heading',
		defaultMessage: "You don't have any product discovery projects",
		description: 'Projects Directory empty state heading for Jira Product Discovery context',
	},
	jiraProductDiscoveryDescription: {
		id: 'projects-directory-v3.page-layout.empty-view.jira-product-discovery-description',
		defaultMessage:
			'Create a new product discovery project to collect insights and ideas to define and prioritize upcoming work for your team.',
		description: 'Projects Directory empty state description for Jira Product Discovery context',
	},
	createProjectPrompt: {
		id: 'projects-directory-v3.page-layout.empty-view.create-project-prompt',
		defaultMessage: 'Create project',
		description: 'Projects Directory empty state create project button prompt',
	},
	businessEmptyStateContactAdminDescription: {
		id: 'projects-directory-v3.page-layout.empty-view.business-empty-state-contact-admin-description',
		defaultMessage: 'Contact your admin to create a business project',
		description:
			'Projects Directory empty state description when user cannot create business project',
	},
	defaultEmptyMessage: {
		id: 'projects-directory-v3.page-layout.empty-view.default-empty-message',
		defaultMessage: 'No projects were found that match your search',
		description: 'Projects Directory empty state no projects found default message',
	},
	defaultEmptyMessageDescription: {
		id: 'projects-directory-v3.page-layout.empty-view.default-empty-message-description',
		defaultMessage: 'Try using specific project names or terms.',
		description: 'Projects Directory empty state no projects found default message description',
	},
});
